<template>
  <div class="ui message">
    <div id="icon-container">
      <i :class="`teal ${icon} icon`"></i>
    </div>
    <span v-html="data.tip"></span>
    <div id="tip-container">
      <a v-if="data.url" :href="data.url">{{data.url}}</a>
    </div>
  </div>
</template>

<script>
import ScormService from '@/services/scorm/scorm.js';
export default {
  name: 'Tip',
  props: ['icon', 'data', 'standard'],
  methods: {
    saveSCORMInteraction() {
      const scormData = {
        id: this.$attrs.id,
        type: this.$attrs.type,
        isCorrect: 'n/a',
        answer: 'n/a',
        description: this.data.tip,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
  },
  mounted() {
    if (this.standard === 'SCORM_2004') {
      this.saveSCORMInteraction();
    }
  },
};
</script>

<style lang="less" scoped>
#icon-container {
  height: 100%;
  width: 2em;
  float: left;
}
#tip-container {
  margin-left: 2em;
}
</style>
